<template>
  <div class="flex">
    <div>

    
      <div class="container mx-auto p-6">
          <h1 class="text-2xl font-bold mb-4">Two-Factor Authentication</h1>
          <p v-if="twoFactorEnabled" class="text-green-600">2FA is currently enabled.</p>
          <p v-else class="text-red-600">2FA is currently disabled.</p>

          <div v-if="qrCode && twoFactorEnabled" class="mt-4">
              <p>Scan the QR code using Google Authenticator or Authy:<br></p>

              <div v-if="qrCode" v-html="qrCode" class="mt-5" ></div>
            <div v-if="!confirmed2fa" >

              {{error}}
              <input v-model="code" type="text" placeholder="Enter the code from your authenticator app" class="mt-4 px-4 py-2 border rounded-md">
              <sp-button @click="confirm2fa" class="mt-4 px-4 py-2 bg-green text-white border-1 rounded-lg" :disabled="loading">
                Confirm 2FA
              </sp-button>
            </div>
            </div>
          <sp-button
              @click="toggle2FA"
              class="mt-4 px-4 py-2 bg-green text-white border-1 rounded-lg"
              :disabled="loading"
          >
              {{ twoFactorEnabled ? "Disable 2FA" : "Enable 2FA" }}
          </sp-button>
      </div>

    </div>
    <div>
      <div class="container mx-auto p-6">
          <h1 class="text-2xl font-bold mb-4">SMS</h1>
   

          <div v-if="smsEnabled" class="mt-4">
             
          </div>
          <div v-if="!smsEnabled" >
            {{error}}
            <p v-if="confirmedsms">Connexion via SMS is Enabled</p>
            <div v-if="!confirmedsms">

              Enter your phone number
              <input v-model="phone" v-if="!requestverificationcode" type="text" placeholder="99999999" class="m-4 px-4 py-2 border rounded-md">
              <input v-model="codesms" v-if="requestverificationcode" type="text" placeholder="123456" class="m-4 px-4 py-2 border rounded-md">
              <sp-button v-if="!requestverificationcode" @click="confirmsms" class="m-4 px-4 py-2 bg-green text-white border-1 rounded-lg" :disabled="loading">
                Confirm Login by SMS
              </sp-button>
              <sp-button v-if="requestverificationcode" @click="confirmcodesms" class="m-4 px-4 py-2 bg-green text-white border-1 rounded-lg" :disabled="loading">
                Confirm code SMS
              </sp-button>
            </div>

            <br>
            <sp-button v-if="confirmedsms" @click="disablesms" class="m-4 px-4 py-2 bg-green text-white border-1 rounded-lg" :disabled="loading">
              Disable SMS
            </sp-button>


          </div>
         
         
      </div>
    </div>
  </div>
  
</template>

<script>

//import { mapGetters } from "vuex";
import { FA_QRCODE } from "@/store/actions.type";
import axios from "axios";
import Button from "@/components/spKit/Button.vue";
//import ApiService from "@/common/api.service";




export default {
  name: "enable2fa",
  components: {
        "sp-button": Button
    },

  data() {
    return {
      twoFactorEnabled :true,
      qrCode:'',
      loading:false,
      res:[],
      error : '',
      confirmed2fa : false,
      phone : '',
      codesms:'',
      code:'',
      requestverificationcode : false,
      confirmedsms:false
    }
  },


  mounted (){
        this.getqrcode();
      },
  
  methods: {

    getqrcode(){

  
     /* this.$store
          .dispatch(FA_QRCODE)
          .then(data => {
            //this.fetchApplications();
            this.qrCode = data.data.data.qr_code_url;
            this.twoFactorEnabled = true;
          });*/
     axios.get("api/fa/qrcode").then(response => {
            console.log(response.data); // Logs the actual data object
            this.qrCode = response.data.data.qr_code_url;
            this.confirmed2fa = response.data.data.confirmed2fa;
            this.confirmedsms = response.data.data.confirmedsms;
            console.log(response.data.data);
            this.twoFactorEnabled = true;
        });
    },
    toggle2FA() {
            this.loading = true;
            try {
                if (this.twoFactorEnabled) {
                    // Disable 2FA
                    axios.post("/api/fa/disable").then(response => {
                        
                        this.qrCode = response.data.data.qr_code_url;
                        
                        this.twoFactorEnabled = false;
                    });
   
                } else {
                    // Enable 2FA
                    axios.post("api/fa/enable").then(response => {
                        
                        this.qrCode = response.data.data.qr_code_url;
                        this.confirmed2fa = response.data.data.confirmed2fa;
                        this.twoFactorEnabled = true;
                    });
                }
            } catch (error) {
                console.error("Error toggling 2FA:", error);
            } finally {
                this.loading = false;
            }
        },
        confirm2fa(){
          axios.post("/api/fa/confirm", { code: this.code })  // Send code to the backend
          .then((response) => {
            this.twoFactorEnabled = true;  
            this.error = response.data.meta.errors[0];
          })
          .catch((error) => {
            this.error = error.data.errors.messages[0];
            console.log(error.data.meta)
          });
        },
        confirmsms(){
          this.requestverificationcode = true;
          axios.post("/api/sms/confirmphone", { phone: this.phone })  // Send code to the backend
          .then((response) => {
            //this.twoFactorEnabled = true;  
           // this.error = response.data.meta.errors[0];
          })
          .catch((error) => {
            this.error = error.data.errors.messages[0];
            console.log(error.data.meta)
          });
        },
        confirmcodesms(){

          axios.post("/api/sms/confirmcode", { codesms: this.codesms })  // Send code to the backend
          .then(() => {
            this.confirmedsms = true;

            //this.twoFactorEnabled = true;  
           // this.error = response.data.meta.errors[0];
          })
          .catch((error) => {
            this.error = error.data.errors.messages[0];
            console.log(error.data.meta)
          });
        },
        disablesms(){

          axios.post("/api/sms/disablesms")  // Send code to the backend
          .then(() => {
            this.confirmedsms = false;
            //this.twoFactorEnabled = true;  
           // this.error = response.data.meta.errors[0];
          })
          .catch((error) => {
            this.error = error.data.errors.messages[0];
            console.log(error.data.meta)
          });
        },


  }
};
</script>
